import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';

import Layout from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import CorporateLeaguesPage from '@/pages/CorporateLeaguesPage';
import WorkforceSystemsPage from '@/pages/WorkforceSystemsPage';
import SportsPerformancePage from '@/pages/SportsPerformancePage';
import NextGenAcademyPage from '@/pages/NextGenAcademyPage';
import RetreatEventsPage from '@/pages/RetreatEventsPage';
import PartnershipPage from '@/pages/PartnershipPage';

function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="brp-overline">404</p>
      <h1 className="font-display uppercase text-5xl md:text-7xl mt-4">Page Not Found</h1>
      <a href="/" className="btn-brp-primary mt-8">Return Home</a>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            color: '#FFFFFF',
            border: '1px solid #D4AF37',
            borderRadius: 0,
            fontFamily: 'DM Sans, sans-serif',
          },
        }}
      />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/corporate-leagues" element={<CorporateLeaguesPage />} />
          <Route path="/workforce-systems" element={<WorkforceSystemsPage />} />
          <Route path="/sports-performance" element={<SportsPerformancePage />} />
          <Route path="/next-gen-academy" element={<NextGenAcademyPage />} />
          <Route path="/retreat-events" element={<RetreatEventsPage />} />
          <Route path="/partnerships" element={<PartnershipPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
